import { Button, ButtonGroup, FormControl, FormHelperText, Grid, InputLabel, Tooltip } from '@material-ui/core';
import { HelpRounded } from '@material-ui/icons';
import React from 'react';
import { DataApi } from '../../../providers/api-provider';
import { handleStateChangeFromProps, renderStringAsHtml } from './helpers';
export default class SwitchInput extends React.Component {
    state = {
        error: '',
        value: null,
        enabled: '',
        onChange: null,
        type: '',
        name: '',
        title: '',
        width: 12,
        data: '',
        renderedData: [],
        description: '',
        disabled: false,
        hidden: false,
    }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */
    componentDidMount() {
        let data = this.state.data;
        if (typeof (data) == 'string') {
            DataApi.getSelect(data).then((res) => {
                this.setState({ renderedData: res.data })
            });

        } else {
            this.setState({ renderedData: data || [] })
        }

    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    static getDerivedStateFromProps(nextProps, prevState) {
        return handleStateChangeFromProps(nextProps, prevState)
    }
    onChange = (value) => {
        this.props.onChange({
            target: {
                type: 'switch',
                value: value,
                name: this.state.name,
            }
        });
    };

    render() {
        const { error, value, enabled, onChange, name, title, width, renderedData,
            description, disabled, hidden } = this.state;
        if (hidden) {
            if (typeof (hidden) !== 'function' || hidden())
                return <div />
        }
        return (
            <Grid item xs={12} sm={width ? width : 12}>
                <FormControl margin={this.props.margin || "normal"} fullWidth error={error && enabled} disabled={disabled} >
                    {description && <Tooltip title={renderStringAsHtml(description)} style={{ alignSelf: 'flex-end' }} placement="top"><HelpRounded fontSize='small' /></Tooltip>}
                    <InputLabel htmlFor={name}>{title} {this.props.required ? '*' : ''}</InputLabel>
                    {title && <div className='bmargin-5'><br /><br /></div>}
                    <ButtonGroup>
                        {renderedData.map((item) => (
                            <Button key={item.id}
                                variant='outlined'
                                color={item.id === value ? 'primary' : 'default'}
                                onClick={() => this.onChange(item.id)}>{item.name}
                            </Button>
                        ))}
                    </ButtonGroup>
                    {error && enabled ? <FormHelperText>{typeof (error) == 'string' ? error : 'this field is required'}</FormHelperText> : ''}
                </FormControl>
            </Grid >
        );
    }
}